import { React, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Link, useNavigate, useParams } from 'react-router-dom'
import Moment from 'react-moment'

import { useGetByIdWorkshopsMutation, useRemoveWorkshopsMutation } from '../../../store/api/endpoints/workhopsApiSlice'

import { openFeedback } from '../../../store/slices/feedback'

import HeaderVista from '../../elementos/HeaderVista'
import Loading from '../../elementos/Loading'

import Button from '@mui/material/Button'
import { Breadcrumbs, Divider, Typography } from '@mui/material'
import Grid from '@mui/material/Grid2'

import OndemandVideoIcon from '@mui/icons-material/OndemandVideo'
import DeleteIcon from '@mui/icons-material/Delete'

export default function DescuentoEliminar() {

    const navigate = useNavigate()
    const dispatch = useDispatch()
    const urlParams = useParams()


    const [
        getRegistro,
        {
            data: responseGetRegistro,
            isUninitialized: isUninitializedGetRegistro,
            isLoading: isLoadingGetRegistro,
            isSuccess: isSuccessGetRegistro,
            isError: isErrorGetRegistro,
            error: errorDataGetRegistro,
        }
    ] = useGetByIdWorkshopsMutation()

    const [
        removeRegistro,
        {
            data: responseRemoveRegistro,
            isUninitialized: isUninitializedRemoveRegistro,
            isLoading: isLoadingRemoveRegistro,
            isSuccess: isSuccessRemoveRegistro,
            isError: isErrorRemoveRegistro,
            error: errorDataRemoveRegistro,
        }
    ] = useRemoveWorkshopsMutation()

    useEffect(() => {
        getRegistro({ id: urlParams.idWorkshop })
    }, [])

    useEffect(() => {
        if (isErrorGetRegistro) {
            dispatch(openFeedback({
                severity: 'error',
                message: errorDataGetRegistro.data.message
            }))
        }
    }, [isErrorGetRegistro])


    useEffect(() => {
        if (isErrorRemoveRegistro) {
            dispatch(openFeedback({
                severity: 'error',
                message: errorDataRemoveRegistro.data.message
            }))
        }
    }, [isErrorRemoveRegistro])

    useEffect(() => {
        if (isSuccessRemoveRegistro) {

            dispatch(openFeedback({
                severity: 'success',
                message: "¡Registro eliminado!"
            }))

            navigate("/workshops")

        }
    }, [isSuccessRemoveRegistro])

    if (isUninitializedGetRegistro || isLoadingGetRegistro || isLoadingRemoveRegistro) return (<Loading />)
    if (isSuccessGetRegistro) return (
        <>
            <HeaderVista
                titulo={
                    <Breadcrumbs aria-label="breadcrumb">
                        <Link to="/workshops">
                            <Typography color="text.primary">Workshops</Typography>
                        </Link>
                        <Link to={`/workshops`}>
                            <Typography color="text.primary">{responseGetRegistro.data.title}</Typography>
                        </Link>
                        <Typography color="text.primary">Eliminar</Typography>
                    </Breadcrumbs>
                }
                icon={<OndemandVideoIcon />}
            />
            <Grid container rowSpacing={2} columnSpacing={1}>
                <Grid size={{ xs: 12, md: 3 }}></Grid>
                <Grid size={{ xs: 12, md: 6 }}>
                    <h3>¿Eliminar Workshop?</h3>
                    <p><img src={responseGetRegistro.data.previewImage} width="100%" /></p>
                    <p>Se eliminará el workshop <b>{responseGetRegistro.data.title}</b> con fecha de publicación <b><Moment date={responseGetRegistro.data.publicationDate} format='DD-MM-YYYY' /></b>.</p>
                </Grid>
                <Grid size={{ xs: 12 }}>
                    <Divider />
                </Grid>
                <Grid size={{ xs: 12 }}>
                    <Button onClick={() => removeRegistro({ id: urlParams.idWorkshop })} type="button" variant="contained" color="error" startIcon={<DeleteIcon />} >
                        Eliminar
                    </Button>
                </Grid>
            </Grid>
        </>
    )

}